/*
 *
 * GenericModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 09-Sep-2024
*/

import { connect } from 'react-redux'
import { doPhonePrefixes } from 'Store/actions/global'
import { nullSafe } from 'Utility/globalMethods'

import ModifyNumberModal from './ModifyNumberModal'

const mapDispatchToProps = dispatch => ({
  doPhonePrefixes: () => dispatch(doPhonePrefixes())
})

const mapStateToProps = state => ({
  title: nullSafe(() => state.popup.popupInfo.title, ''),
  description: nullSafe(() => state.popup.popupInfo.description, ''),
  onClose: nullSafe(() => state.popup.popupInfo.onClose, () => { }),
  primaryButtonLabel: nullSafe(() => state.popup.popupInfo.primaryButtonLabel, ''),
  secondaryButtonLabel: nullSafe(() => state.popup.popupInfo.secondaryButtonLabel, ''),
  secondaryAction: nullSafe(() => state.popup.popupInfo.secondaryAction, () => { }),
  primaryAction: nullSafe(() => state.popup.popupInfo.primaryAction, () => { }),
  telephoneNumber: nullSafe(() => state.popup.popupInfo.telephoneNumber, ''),
  telephonePrefix: nullSafe(() => state.popup.popupInfo.telephonePrefix, ''),
  phonePrefixes: nullSafe(() => state.global.phonePrefixes, []),
  defaultPrefix: nullSafe(() => state.global.defaultPrefix, {}),
  isPhonePrefixesLoading: nullSafe(() => state.loading.localLoading.phone_prefixes, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ModifyNumberModal)
